/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */

import { TLocalizationKey } from 'types/i18n';
import { ISOs } from 'utils/form/constants';

export const messageIdMap = {
  [ISOs.ARE]: 'unitedArabEmirates',
  [ISOs.ATA]: 'antarctica',
  [ISOs.AUT]: 'austria',
  [ISOs.AUS]: 'australia',
  [ISOs.BHR]: 'bahrain',
  [ISOs.CAN]: 'canada',
  [ISOs.CHE]: 'switzerland',
  [ISOs.CZE]: 'czechRepublic',
  [ISOs.DEU]: 'germany',
  [ISOs.ESP]: 'spain',
  [ISOs.EGY]: 'egypt',
  [ISOs.FRA]: 'france',
  [ISOs.GBR]: 'unitedKingdom',
  [ISOs.IRL]: 'ireland',
  [ISOs.KOR]: 'southKorea',
  [ISOs.KWT]: 'kuwait',
  [ISOs.MAR]: 'morocco',
  [ISOs.MYS]: 'malaysia',
  [ISOs.NLD]: 'netherlands',
  [ISOs.NZL]: 'newZealand',
  [ISOs.OMN]: 'oman',
  [ISOs.PHL]: 'philippines',
  [ISOs.POL]: 'poland',
  [ISOs.PRT]: 'portugal',
  [ISOs.QAT]: 'qatar',
  [ISOs.ROU]: 'romania',
  [ISOs.SAU]: 'saudiArabia',
  [ISOs.SGP]: 'singapore',
  [ISOs.TWN]: 'taiwan',
  [ISOs.USA]: 'unitedStates',
  [ISOs.ZAF]: 'southAfrica',
} as const satisfies Record<ISOs, TLocalizationKey>;

export const countriesList: ISOs[] = [
  ISOs.ARE,
  ISOs.ATA,
  ISOs.AUT,
  ISOs.AUS,
  ISOs.BHR,
  ISOs.CAN,
  ISOs.CHE,
  ISOs.CZE,
  ISOs.DEU,
  ISOs.ESP,
  ISOs.EGY,
  ISOs.FRA,
  ISOs.GBR,
  ISOs.IRL,
  ISOs.KOR,
  ISOs.KWT,
  ISOs.MAR,
  ISOs.MYS,
  ISOs.NLD,
  ISOs.NZL,
  ISOs.OMN,
  ISOs.PHL,
  ISOs.POL,
  ISOs.PRT,
  ISOs.QAT,
  ISOs.ROU,
  ISOs.SAU,
  ISOs.SGP,
  ISOs.TWN,
  ISOs.USA,
  ISOs.ZAF,
];
